import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class APIPaymentService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }
    public GetNewgstRegistration(EntityID): Observable<any> {
        return this.http.get(APIConstants.GETNEWGSTREGISTRATION + '?EntityID=' + EntityID);

    }
    public newgstRegistration(data): Observable<any> {
        return this.http.post(APIConstants.NEWGSTREGISTRATION, data);

    }
    // public GetNewpaymentSubmit(data): Observable<any> {
    //     return this.http.get(APIConstants.GETNEWPAYMENTSUBMIT + '/' + data);

    // }

    public getPaymentHistoryInfo(entityID, pageno): Observable<any> {
        return this.http.get(APIConstants.GETPAYMENTHISTORYINFO + '?EntityID=' + entityID + '&pageNo=' + pageno);

    }
	
	// public PaymentHistorySearchInfo(entityID, pageno): Observable<any> {
    //     return this.http.get(APIConstants.PAYMENTHISTORYSEARCHINFO + '/' + entityID + '/' + pageno);

    // }

    public paymentdues(entityID, pageno): Observable<any> {
        return this.http.get(APIConstants.PAYMENTDUES + '?EntityID=' + entityID + '&pageNo=' + pageno);

    }

    public getnewPaymentHistoryInfo(entityID): Observable<any> {
        return this.http.get(APIConstants.GETNEWPAYMENHISTORYTINFO + '?EntityID=' + entityID);
    }
	
    public PaymentHistorySearchInfo(entityID, status, pageNo, pageSize): Observable<any> {
        return this.http.get(APIConstants.PAYMENTHISTORYINFO + '?EntityID=' + entityID + '&PaymentOrderStatus=' + status + '&pageNo=' +  pageNo + '&pageSize=' + pageSize);
    }


    // public newpaymentSubmit(data): Observable<any> {
    //     return this.http.post(APIConstants.NEWPAYMENTSUBMIT, data);

    // } 
 public postpaymentresp(data): Observable<any> {
       // return this.http.post('http://10.104.52.6:8082/ibppayresp', data);
        //return this.http.post(APIConstants.POSTPAYMENTRESPONSE, data);
		return this.http.post(APIConstants.IBPPAYMENTRESPONSE, data);
		
        
    }
    public placeDLTPaymentOrder(data): Observable<any> {
        return this.http.post(APIConstants.POSTDLTPAYMENTORDER, data);
    }

    public fetchDLTPaymentOrder(dltordernum): Observable<any> {
        return this.http.get(APIConstants.GETDLTPAYMENTORDER+'?dltordernumber='+ dltordernum);
    }

    public getGSTNumbersByEntityID(entityID): Observable<any> {
        return this.http.get(APIConstants.GSTNUMBYENTITY + '?EntityID=' + entityID);
        // return Observable.of([
        //     "03AAACT2438A1Z3",
        //     "02AAACT2438A1Z5",
        //     "03AAACT2438A1Z3",
        //     "04AAACT2438A1Z1",
        //     "05AAACT2438A1ZZ",
        //     "06AAACT2438A2ZW",
        //     "07AAACT2438A1ZV",
        //     "08AAACT2438A1ZT",
        //     "09AAACT2438A1ZR",
        //     "10AAACT2438A1Z8",
        //     "11AAACT2438A1Z6",
        //     "12AAACT2438A1Z4",
        //     "13AAACT2438A1Z2",
        //     "14AAACT2438A1Z0",
        //     "15AAACT2438A1ZY",
        //     "16AAACT2438A1ZW",
        //     "17AAACT2438A1ZU",
        //     "18AAACT2438A1ZS",
        //     "19AAACT2438A1ZQ",
        //     "20AAACT2438A1Z7",
        //     "21AAACT2438A1Z5",
        //     "22AAACT2438A1Z3",
        //     "23AAACT2438A1Z1",
        //     "24AAACT2438A1ZZ",
        //     "24AAACT2438A1ZZ",
        //     "24AAACT2438A1ZZ",
        //     "27AAACH1458C1ZZ",
        //     "27AAACT2438A1ZT",
        //     "29AAACT2438A1ZP",
        //     "27AAACT2438A1ZT",
        //     "30AAACH1458C1ZC",
        //     "32AAACT2438A1Z2",
        //     "32AAACT2438A1Z2",
        //     "33AAACT2438A1Z0",
        //     "34AAACT2438A1ZY",
        //     "36AAACT2438A1ZU",
        //     "37AAACT2438A1ZS"
        // ])

    }
    public getstates(): any[] {
        return [
            { 'stateid': 1, 'statename': 'Jammu and Kashmir' }
            , { 'stateid': 2, 'statename': 'Himachal Pradesh' }
            , { 'stateid': 3, 'statename': 'Punjab' }
            , { 'stateid': 4, 'statename': 'Chandigarh' }
            , { 'stateid': 5, 'statename': 'Uttarakhand' }
            , { 'stateid': 6, 'statename': 'Haryana' }
            , { 'stateid': 7, 'statename': 'Delhi' }
            , { 'stateid': 8, 'statename': 'Rajasthan' }
            , { 'stateid': 9, 'statename': 'Uttar Pradesh' }
            , { 'stateid': 10, 'statename': 'Bihar' }
            , { 'stateid': 11, 'statename': 'Sikkim' }
            , { 'stateid': 12, 'statename': 'Arunachal Pradesh' }
            , { 'stateid': 13, 'statename': 'Nagaland' }
            , { 'stateid': 14, 'statename': 'Manipur' }
            , { 'stateid': 15, 'statename': 'Mizoram' }
            , { 'stateid': 16, 'statename': 'Tripura' }
            , { 'stateid': 17, 'statename': 'Meghalaya' }
            , { 'stateid': 18, 'statename': 'Assam' }
            , { 'stateid': 19, 'statename': 'West Bengal' }
            , { 'stateid': 20, 'statename': 'Jharkhand' }
            , { 'stateid': 21, 'statename': 'Odisha' }
            , { 'stateid': 22, 'statename': 'Chattisgarh' }
            , { 'stateid': 23, 'statename': 'Madhya Pradesh' }
            , { 'stateid': 24, 'statename': 'Gujarath' }
            , { 'stateid': 25, 'statename': 'Daman and Diu' }
            , { 'stateid': 26, 'statename': 'Dadra and Nagar Haveli' }
            , { 'stateid': 27, 'statename': 'Maharashtra' }
            , { 'stateid': 27, 'statename': 'Maharashtra' }
            , { 'stateid': 29, 'statename': 'Karnataka' }
            , { 'stateid': 30, 'statename': 'Goa' }
            , { 'stateid': 30, 'statename': 'Goa' }
            , { 'stateid': 31, 'statename': 'Lakshadweep Islands' }
            , { 'stateid': 32, 'statename': 'Kerala' }
            , { 'stateid': 33, 'statename': 'Tamil Nadu' }
            , { 'stateid': 34, 'statename': 'Pondicherry' }
            , { 'stateid': 36, 'statename': 'Telangana' }
            , { 'stateid': 37, 'statename': 'Andhra Pradesh ' }]
    }

    public checkPOInEclassAvailabiltiy(data): Observable<any> {
        return this.http.post(APIConstants.CHKPOIAVAILABILITY, data);
    } 

    public updateSecondaryEntityReg(data): Observable<any> {
        return this.http.post(APIConstants.SECONDARYENTITYREG, data);
    } 
}


